import classNames from "classnames";
import AppContext from "PFApp/app_context";
import { RowType } from "PFApp/booking/types/row";
import EngagementIconSvg from "PFIcons/engagement.svg";
import RoleIconSvg from "PFIcons/role.svg";
import SearchFatIcon from "PFIcons/search_fat.svg";
import UserIcon from "PFIcons/user.svg";
import React, { PropsWithChildren, useContext } from "react";

import css from "./activity_icon.module.scss";

interface IAuditActivityIconProps {
  classes: Record<string, string>;
  badgeIconProps: Record<string, any>;
}

const AuditActivityIcon = ({
  children,
  classes = {},
  badgeIconProps
}: PropsWithChildren<IAuditActivityIconProps>) => (
  <div className={classNames(css.auditActivityIconContainer, classes.container)}>
    <div className={classNames(css.auditActivityIconBadge, classes.badge)}>
      <SearchFatIcon {...badgeIconProps} />
    </div>
    {children}
  </div>
);

const RoleIcon = ({ iconProps }) => (
  <RoleIconSvg viewBox="5 2 13 14" fill="var(--Palette-text)" {...iconProps} />
);
const EngagementIcon = ({ iconProps }) => (
  <EngagementIconSvg viewBox="4 2 16 15" fill="var(--Palette-text)" {...iconProps} />
);

const activityIcons = {
  role: RoleIcon,
  engagement: EngagementIcon,
  // eslint-disable-next-line camelcase
  audit_role: ({ iconProps, wrapperProps }) => (
    <AuditActivityIcon {...wrapperProps}>
      <RoleIcon iconProps={iconProps} />
    </AuditActivityIcon>
  ),
  // eslint-disable-next-line camelcase
  audit_engagement: ({ iconProps, wrapperProps }) => (
    <AuditActivityIcon {...wrapperProps}>
      <EngagementIcon iconProps={iconProps} />
    </AuditActivityIcon>
  ),
  profile: ({ iconProps }) => <UserIcon viewBox="4 4 12 12" fill="var(--Palette-text)" {...iconProps} />
};

interface UseRowIconComponent {
  templateId: number | null;
  type: string;
}

export const useRowIconComponent = ({ templateId, type }: UseRowIconComponent) => {
  const {
    store: { currentProfile }
  } = useContext(AppContext);
  const templateKey =
    type !== RowType.Profile ? currentProfile.templates?.find(({ id }) => id === templateId)?.key : null;
  return activityIcons[templateKey || type];
};
